/* web/style.css #map-ui / .map-bottom / .circle-btn */
.ui { position: absolute; left: var(--panel-w); right: 0; bottom: 0; padding: 12px 12px 34px; pointer-events: none; z-index: 1; display: flex; flex-direction: column; gap: 10px; transition: opacity .2s; }
:global(body.filters-open) .ui { opacity: 0; }
:global(body.filters-open) .ui * { pointer-events: none !important; }
.bottom { display: flex; align-items: flex-end; justify-content: space-between; gap: 10px; pointer-events: none; }
.bottom > * { pointer-events: auto; }
.left { flex: 0 1 auto; min-width: 0; display: flex; flex-direction: column; gap: 10px; }
.left:empty { display: none; }
.buttons { flex: none; display: flex; flex-direction: column; gap: 10px; margin-left: auto; }
.circle { display: inline-flex; align-items: center; justify-content: center; line-height: 1; padding: 0; width: 50px; height: 50px; border-radius: 50%; border: 0; background: var(--surface); color: var(--text); box-shadow: var(--shadow); }
.circle :global(.icon) { width: 24px; height: 24px; }
.circle:hover { filter: brightness(.97); }
@media (max-width: 760px) {
  .ui { left: 0; bottom: var(--nearby-h, 0px); padding-bottom: 12px; transition: bottom .25s var(--ease), opacity .2s; }
  :global(body.sheet-open) .ui { display: none; }
}
